import { inject, InjectionToken, Provider } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';

import { LangRouteString } from '../enums/route-string';

function defaultLang() {
  const _langs: Array<string> = Object.values(LangRouteString);
  const userLang = navigator.language;

  const _cookieService = inject(CookieService);
  const lang = _cookieService.get('LANG_CODE');
  if (_langs.some((x) => x === lang)) {
    return lang;
  }
  if (_langs.some((x) => x === userLang)) {
    return userLang;
  }

  return 'en';
}

export const DEFAULT_LANG = new InjectionToken<string>('DEFAULT_LANG');

export const defaultLangProvider: Provider = {
  provide: DEFAULT_LANG,
  useFactory: defaultLang,
};
